module.exports = __webpack_public_path__ + "customFactor@2x.f685370562cacdef3bffced95dd9d136.png";